export default {
  moduleEl: document.querySelector('.module-numbers'),
  numberEls: null,
  numbers: [],
  duration: 1500,
  interval: 30,
  separator: ',',
  init() {
    if (!this.moduleEl) return;
    this.numberEls = document.querySelectorAll('.js-number');
    if (this.numberEls.length === 0) return;

    this.separator = this.moduleEl.dataset.language.startsWith('de') ? '.' : ',';

    this.initNumbers();

    window.smr_eventbus.on('observer:InView', (el) => {
      if (!el.classList.contains('js-number')) return;
      window.smr_observer.removeEl(el);

      const index = Array.from(this.numberEls).indexOf(el);

      setTimeout(() => {
        this.startCounting(index);
      }, 250);
    });
  },
  initNumbers() {
    this.numberEls.forEach((number) => {
      const target = parseInt(number.dataset.number, 10);
      this.numbers.push({
        el: number.querySelector('.js-number-counter') || number,
        target,
        current: 0,
        stepSize: (target / this.duration) * this.interval,
      });
    });
  },
  startCounting(index) {
    this.numbers[index].el.textContent = '0';
    this.numbers[index].current = 0;
    const interval = setInterval(() => {
      const current = this.numbers[index].current;
      const next = current + this.numbers[index].stepSize;
      const target = this.numbers[index].target;
      if (next < target) {
        this.numbers[index].el.textContent = this.formatNumber(
          Math.round(next),
          target
        );
        this.numbers[index].current = next;
      } else {
        this.numbers[index].el.textContent = this.formatNumber(target, target);
        clearInterval(interval);
      }
    }, this.interval);
  },
  formatNumber(number, target) {
    if (target > 2000 && target < 2050) return number;
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.separator);
  },
};
